// extracted by mini-css-extract-plugin
export default {"products":"jv-z","card":"kv-z","oosMessaging":"lv-z"};